<div>
  <p>
    Hieronder kun je er voor kiezen om automatisch een standaard {{ isNbaAccountant ? "NBA " : "" }}verklaring te genereren bij de jaarrapportage.
    <br/>
  </p>

  <form [formGroup]="nbaAccountantFg">
    <label for="continuiteit" class="form-label">
      Verklaring volledig conform NBA standaard, inclusief officiële voor accountants geldende standaarden en VGBA terminologie?
    </label>
    <div>
      <snelstart-ui-select-form-control formControlName="value"
                                        id="nbaAccountant"
                                        [options]="optionsJaNee"
                                        class="me-1 custom-input-250"
      >
      </snelstart-ui-select-form-control>
    </div>
  </form>

  <form [formGroup]="engagementTypeFg">
    <div>
      <snelstart-ui-text-form-control formControlName="value"
                                        id="engagementTypeFg"
                                        label="Soort opdracht"
                                        class="me-1 custom-input-250 custom-readonly"
                                        >
      </snelstart-ui-text-form-control>

    </div>
  </form>

  <form [formGroup]="continuiteitFg">
    <label for="continuiteit" class="form-label">
      Is er sprake van onzekerheid over de continuïteit van de onderneming?
    </label>
    <div>
      <snelstart-ui-select-form-control formControlName="value"
                                        id="continuiteit"
                                        [options]="optionsJaNee"
                                        class="me-1 custom-input-250"
                                        >
      </snelstart-ui-select-form-control>
    </div>
  </form>

  <ng-container>
    <div>
      <snelstart-ui-button [config]="verklaringGenereren" type="primary"
                           class="me-1 pt-1 custom-input-250">
        Verklaring genereren
      </snelstart-ui-button>
    </div>
  </ng-container>

  <p>
    <br/>
    <b>Let op:</b> maak je na het genereren wijzigingen in bepaalde gegevens van informatie rapportage of informatie entiteit, dan worden deze gewijzigde gegevens NIET automatisch opgenomen in een reeds gegenereerde verklaring. Deze stap dient dan eventueel opnieuw te worden uitgevoerd.
    <br/><br/>
    Het gaat hierbij om de volgende gegevens:<br/>
    - Naam en zetel onderneming<br/>
    - Rechtsvorm<br/>
    - KvK-nummer<br/>
    - Start- en einddatum van de rapportageperiode
  </p>
</div>
